import { useEffect, useRef } from 'react';

import { usemarkPendingChatMessagesDeliveredMutation } from '@/types/generated/graphql';

export function useAcknowledgePendingDelivery() {
  const [markPending] = usemarkPendingChatMessagesDeliveredMutation({
    onError: () => {},
  });

  const sent = useRef(false);

  useEffect(() => {
    if (!sent.current) {
      sent.current = true;
      markPending();
    }

    function onOnline() {
      markPending();
    }

    window.addEventListener('online', onOnline);

    return () => window.removeEventListener('online', onOnline);
  }, [markPending]);
}
